export const bacteriaLayoutConfig_bwcallergy_eng = [
    {
        label: 'Candida albicans',
        page: 5,
        yOffset: 190,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 180,
        yResult: 180,
        yResulttext: 184,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Escherichia coli',
        page: 5,
        yOffset: 229,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 219,
        yResult: 219,
        yResulttext: 223,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Ruminococcus bromii',
        page: 5,
        yOffset: 268,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 258,
        yResult: 258,
        yResulttext: 262,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Staphylococcus aureus',
        page: 5,
        yOffset: 307,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 297,
        yResult: 297,
        yResulttext: 301,
        xResulttext: 555,
        show_result: true
    }, 
    {
        label: 'Akkermansia muciniphila',
        page: 5,
        yOffset: 390,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 380,
        yResult: 380,
        yResulttext: 384,
        xResulttext: 555,
        show_result: true
    }, 
    {
        label: 'Faecalibacterium prausnitzii',
        page: 5,
        yOffset: 429,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 419,
        yResult: 419,
        yResulttext: 423,
        xResulttext: 555,
        show_result: true
    }, 
    {
        label: 'Bifidobacterium bifidum',
        page: 5,
        yOffset: 512,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 502,
        yResult: 502,
        yResulttext: 506,
        xResulttext: 555,
        show_result: true
    }, 
    {
        label: 'Bifidobacterium lactis',
        page: 5,
        yOffset: 551,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 541,
        yResult: 541,
        yResulttext: 545,
        xResulttext: 555,
        show_result: true
    }, 
    {
        label: 'Lactobacillus acidophilus',
        page: 5,
        yOffset: 590,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 580,
        yResult: 580,
        yResulttext: 584,
        xResulttext: 555,
        show_result: true
    }, 
    {
        label: 'Lactobacillus reuteri',
        page: 5,
        yOffset: 629,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 619,
        yResult: 619,
        yResulttext: 623,
        xResulttext: 555,
        show_result: true
    }, 
    {
        label: 'Lactobacillus rhamnosus',
        page: 5,
        yOffset: 668,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 658,
        yResult: 658,
        yResulttext: 662,
        xResulttext: 555,
        show_result: true
    }, 
    {
        label: 'Candida albicans',
        page: 9,
        yOffset: 102,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 92,
        yResult: 658,
        yResulttext: 96,
        xResulttext: 555,
        show_result: false
    }, 
    {
        label: 'Escherichia coli',
        page: 9,
        yOffset: 275,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 265,
        yResult: 658,
        yResulttext: 269,
        xResulttext: 555,
        show_result: false
    }, 
    {
        label: 'Ruminococcus bromii',
        page: 9,
        yOffset: 474,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 464,
        yResult: 658,
        yResulttext: 468,
        xResulttext: 555,
        show_result: false
    }, 
    {
        label: 'Staphylococcus aureus',
        page: 9,
        yOffset: 647,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 637,
        yResult: 658,
        yResulttext: 641,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Akkermansia muciniphila',
        page: 10,
        yOffset: 105,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 95,
        yResult: 658,
        yResulttext: 99,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 10,
        yOffset: 275,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 265,
        yResult: 658,
        yResulttext: 269,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Bifidobacterium bifidum',
        page: 11,
        yOffset: 102,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 92,
        yResult: 658,
        yResulttext: 96,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Bifidobacterium lactis',
        page: 11,
        yOffset: 343,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 333,
        yResult: 658,
        yResulttext: 337,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Lactobacillus acidophilus',
        page: 11,
        yOffset: 604,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 594,
        yResult: 658,
        yResulttext: 598,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Lactobacillus reuteri',
        page: 12,
        yOffset: 70,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 60,
        yResult: 658,
        yResulttext: 64,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Lactobacillus rhamnosus',
        page: 12,
        yOffset: 247,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 237,
        yResult: 658,
        yResulttext: 241,
        xResulttext: 555,
        show_result: false
    }
];

export const bacteriaLayoutConfig_bwcallergy_thai = [
    {
        label: 'Candida albicans',
        page: 4,
        yOffset: 190,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 180,
        yResult: 180,
        yResulttext: 184,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Escherichia coli',
        page: 4,
        yOffset: 229,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 219,
        yResult: 219,
        yResulttext: 223,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Ruminococcus bromii',
        page: 4,
        yOffset: 268,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 258,
        yResult: 258,
        yResulttext: 262,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Staphylococcus aureus',
        page: 4,
        yOffset: 307,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 297,
        yResult: 297,
        yResulttext: 301,
        xResulttext: 555,
        show_result: true
    }, 
    {
        label: 'Akkermansia muciniphila',
        page: 4,
        yOffset: 390,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 380,
        yResult: 380,
        yResulttext: 384,
        xResulttext: 555,
        show_result: true
    }, 
    {
        label: 'Faecalibacterium prausnitzii',
        page: 4,
        yOffset: 429,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 419,
        yResult: 419,
        yResulttext: 423,
        xResulttext: 555,
        show_result: true
    }, 
    {
        label: 'Bifidobacterium bifidum',
        page: 4,
        yOffset: 512,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 502,
        yResult: 502,
        yResulttext: 506,
        xResulttext: 555,
        show_result: true
    }, 
    {
        label: 'Bifidobacterium lactis',
        page: 4,
        yOffset: 551,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 541,
        yResult: 541,
        yResulttext: 545,
        xResulttext: 555,
        show_result: true
    }, 
    {
        label: 'Lactobacillus acidophilus',
        page: 4,
        yOffset: 590,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 580,
        yResult: 580,
        yResulttext: 584,
        xResulttext: 555,
        show_result: true
    }, 
    {
        label: 'Lactobacillus reuteri',
        page: 4,
        yOffset: 629,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 619,
        yResult: 619,
        yResulttext: 623,
        xResulttext: 555,
        show_result: true
    }, 
    {
        label: 'Lactobacillus rhamnosus',
        page: 4,
        yOffset: 668,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 658,
        yResult: 658,
        yResulttext: 662,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Candida albicans',
        page: 8,
        yOffset: 105,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 95,
        yResult: 658,
        yResulttext: 99,
        xResulttext: 555,
        show_result: false
    }, 
    {
        label: 'Escherichia coli',
        page: 8,
        yOffset: 285,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 275,
        yResult: 658,
        yResulttext: 279,
        xResulttext: 555,
        show_result: false
    }, 
    {
        label: 'Ruminococcus bromii',
        page: 8,
        yOffset: 443,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 433,
        yResult: 658,
        yResulttext: 437,
        xResulttext: 555,
        show_result: false
    }, 
    {
        label: 'Staphylococcus aureus',
        page: 8,
        yOffset: 600,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 590,
        yResult: 658,
        yResulttext: 594,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Akkermansia muciniphila',
        page: 9,
        yOffset: 110,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 100,
        yResult: 658,
        yResulttext: 104,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 9,
        yOffset: 258,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 248,
        yResult: 658,
        yResulttext: 252,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Bifidobacterium bifidum',
        page: 10,
        yOffset: 107,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 97,
        yResult: 658,
        yResulttext: 103,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Bifidobacterium lactis',
        page: 10,
        yOffset: 346,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 336,
        yResult: 658,
        yResulttext: 340,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Lactobacillus acidophilus',
        page: 10,
        yOffset: 566,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 556,
        yResult: 658,
        yResulttext: 560,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Lactobacillus reuteri',
        page: 11,
        yOffset: 73,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 63,
        yResult: 658,
        yResulttext: 67,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Lactobacillus rhamnosus',
        page: 11,
        yOffset: 248,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 650,
        yLabel: 238,
        yResult: 658,
        yResulttext: 242,
        xResulttext: 555,
        show_result: false
    }
];